<template>
  <div>
      <!-- Content Header (Page header) -->
      <div class="content-header">
          <div class="container-fluid">
              <div class="row mb-2">
                  <div class="col-sm-6">
                      <h1 class="m-0 text-dark"><i class="nav-icon fas fa-tachometer-alt"></i> Dashboard</h1>
                  </div>
                  <!-- /.col -->
                  <div class="col-sm-6">
                      <ol class="breadcrumb float-sm-right">
                          <li class="breadcrumb-item">
                              <router-link to="/dashboard">
                                  <i class="nav-icon fas fa-home"></i> Home
                              </router-link>
                          </li>
                          <li class="breadcrumb-item active"><i class="nav-icon fas fa-tachometer-alt"></i> Dashboard</li>
                      </ol>
                  </div>
                  <!-- /.col -->
              </div>
              <!-- /.row -->
          </div>
          <!-- /.container-fluid -->
      </div>
      <!-- /.content-header -->
      <!-- Main content -->
      <section class="content">
        <div class="container-fluid">
              <div class="card card-primary card-outline">

                  <div class="card-body text-center">

                    <img src="https://dryko.com.br/wp-content/themes/dryko-theme/dist/images/novo_logo.png">
                      
                  </div>
                  <div class="card-footer">
                  </div>
              </div>
          </div>
          <!-- /.container-fluid -->
      </section>
      <!-- /.content -->
  </div>
</template>

<script>
  export default {     
  };
</script>

<style scoped>
</style>